var r = /* @__PURE__ */ ((t) => (t.DEFAULT = "default", t.COMPACT = "compact", t))(r || {});
export {
  r as RocheUIAccordionAppearance
};
